// Bars deepen left to right: the newest at full color, each older one a step fainter, the oldest
// at the prior-year opacity the monthly charts use.
const OLDEST_OPACITY = 0.25

export function fadeIn(count) {
  const step = count > 1 ? (1 - OLDEST_OPACITY) / (count - 1) : 0
  return Array.from({length: count}, (_, index) => Number((1 - step * (count - 1 - index)).toFixed(3)))
}
